module.exports = __webpack_public_path__ + "fonts/c045b73.ttf";